export default __webpack_public_path__ + "static/media/CNo.77-2.f9000035.jpg";